import handleDarkMode from "./composed/handleDarkMode.js";
import uikitcomponents from "./composed/uikitcomponents.js";
import initprojecthub from "./composed/projecthub.js";

document.addEventListener("DOMContentLoaded", firstLoadInit);

function genericInit() {
    handleDarkMode.init();
    uikitcomponents.init();
    initprojecthub();
}

function firstLoadInit() {
    genericInit();
}